jQuery( function($){

    var $slider_string  = '.js-slider-trayectoria';
    var $slider         = $($slider_string);

    $slider.each( function (i, el) {
        var $this               = $(el);
        var $slider__slides     = $this.find($slider_string+'__slides');
        var $slider__controls   = $this.find($slider_string+'__controls');

        $slider__slides.slick({
            dots: true,
            arrows: false,
            infinite: true,
            autoplay: false,
            slidesToShow: 1,
            appendDots: $slider__controls
        });
    });

});
